export const mainMenu = [{
  label: 'Sobre nosotros',
  anchor: '/ve/#alliance'
},{
  label: 'Funcionalidad',
  anchor: '/ve/#modulos'
},{
  label: 'Planes',
  anchor: '/ve/#planes'
},{
  label: 'Conoce Alliance',
  anchor: '/ve/#videoPrincipal'
},
// {
//   label: 'Quédate en casa',
//   anchor: '/#quedateencasa'
// },
{
  label: 'Contáctanos',
  anchor: '#contacto'
}];


export const mainMenuPa = [{
  label: 'Sobre nosotros',
  anchor: '/pa/#alliance'
},{
  label: 'Funcionalidad',
  anchor: '/pa/#modulos'
},{
  label: 'Planes',
  anchor: '/pa/#planes'
},{
  label: 'Conoce Alliance',
  anchor: '/pa/#videoPrincipal'
}, 
{
  label: 'Contáctanos',
  anchor: '#contacto'
}];
